// extracted by mini-css-extract-plugin
export default {"enter":"background_enter__N3-DA","enterActive":"background_enterActive__FGOCV","exit":"background_exit__AGkQd","exitActive":"background_exitActive__rTcjv"};